<script>
export default {
  name: 'pagination',
  props: {
    page: Number,
    perPage: Number,
    recordsTotal: Number,
  },
  computed: {
    pagination() {
      const current = this.page + 1;
      const last = Math.ceil(this.recordsTotal / this.perPage);
      const delta = Math.max(5 - current, 4 - last + current, 1);
      const left = current - delta;
      const right = current + delta + 1;
      const range = [];

      let prev = 1;
      for (let i = 1; i <= last; i += 1) {
        if (i === 1 || i === last || (i >= left && i < right)) {
          if (i - prev > 1) {
            range.push('…');
          }
          range.push(i);
          prev = i;
        }
      }

      return range;
    },
  },
  methods: {
    changePage(page, { parentElement }) {
      if (parentElement.classList.contains('disabled') || page === this.page) {
        return;
      }

      this.$emit('page', page);
    },
  },
};
</script>

<template>
  <ul class="pagination">
    <li
      class="page-item"
      :class="{ disabled: page === 0 }"
    >
      <a 
        href="#"
        tabindex="0"
        @click.prevent="changePage(page - 1, $event.target)"
        class="page-link"
      >Previous</a>
    </li>

    <li
      v-for="(p, index) of pagination"
      :key="index"
      class="page-item"
      :class="{
        disabled: p === '…',
        active: p - 1 === page,
      }"

    >
      <a href="#" tabindex="0" @click.prevent="changePage(p - 1, $event.target)"
        class="page-link"
      >{{ p }}</a>
    </li>

    <li
      class="page-item"
      :class="{ disabled: page === Math.ceil(this.recordsTotal / this.perPage) - 1 }"
    >
      <a 
        href="#" 
        tabindex="0" 
        class="page-link" 
        @click.prevent="changePage(page + 1, $event.target)"
      >Next</a>
    </li>
  </ul>
</template>

<style scoped>
.pagination > li:not(.active) > a:not(:hover):focus {
  background-color: #fff;
  border-color: #ddd;
  color: #373e4a;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue